import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { FormStateService } from '../../module/service-provider/add-sp-new-component/form-state.service';
import { ToastService } from '../../Service/ToastService/toast.service';
import { FormGroup } from '@angular/forms';
@Component({
  selector: 'app-map-location',
  templateUrl: './map-location.component.html',
  styleUrl: './map-location.component.scss'
})
export class MapLocationComponent implements OnInit, OnDestroy, AfterViewInit {
  map!: google.maps.Map;
  searchBox!: google.maps.places.SearchBox;
  marker!: any;
  address: string = '';
  coordinates: string = '';
  lat!: number;
  lng!: number;
  city: string = '';
  state: string = '';
  zip: string = '';
  country: string = '';
  district: string = '';
  @Output() nextSection = new EventEmitter<void>();
  role: string = '';
  @Input() formStateService: any;
  @Input() formSource: any = 'unknown';
  // @Input() form: FormGroup = new FormGroup({});


  constructor(
    private router: Router,
    // private locationDataService: LocationService,
    // private spService: ServiceProviderService,
    private cdr: ChangeDetectorRef,
    private toastService: ToastService,
    private formstate: FormStateService
  ) { }
  ngOnInit(): void {
    this.loadSavedLocation()
    this.initMap();
    console.log(`MapLocationComponent initialized for module: ${this.formSource}`);
  }
  ngOnDestroy(): void {
    this.saveLocation()
  }

  ngAfterViewInit(): void {
    const mapEl = document.getElementById('map');
    if (mapEl) {
      this.initMap();
    } else {
      setTimeout(() => this.initMap(), 300); // Fallback
    }
  }

  loadSavedLocation(): void {
    if (!this.map) {
      console.warn('Map not ready. Skipping loadSavedLocation.');
      return;
    }

    const savedLocation = this.formstate?.getFormData('map-location');
    console.log('Saved Location Data:', savedLocation);
    if (savedLocation) {
      console.log('Loaded Saved Location:', savedLocation);
      this.lat = savedLocation.latitude;
      this.lng = savedLocation.longitude;
      this.address = savedLocation.address;
      this.city = savedLocation.city;
      this.state = savedLocation.state;
      this.zip = savedLocation.zip;
      this.country = savedLocation.country;

      const position = new google.maps.LatLng(this.lat, this.lng);
      this.addMarker(position);
      this.patchLocationOnMap(position);

      if (!this.address && this.lat && this.lng) {
        const position = new google.maps.LatLng(this.lat, this.lng);
        this.fetchAddress(position); // just get it again
      }
      this.cdr.detectChanges();
    }

  }



  patchLocationOnMap(position: google.maps.LatLng): void {
    if (!this.map) {
      console.warn('Map not ready in patchLocationOnMap().');
      return;
    }

    if (this.marker) {
      this.marker.setPosition(position);
    } else {
      this.marker = new google.maps.marker.AdvancedMarkerElement({
        position,
        map: this.map,
        title: 'Selected Location',
      });
    }

    this.map.setCenter(position);
    this.coordinates = `${this.lat}, ${this.lng}`;
    this.cdr.detectChanges();
  }
  initMap(): void {
    const mapOptions: google.maps.MapOptions = {
      center: { lat: 20.76696, lng: 86.152857 },
      zoom: 15,
    };
    this.map = new google.maps.Map(
      document.getElementById('map') as HTMLElement,
      mapOptions
    );
    const input = document.getElementById('search-box') as HTMLInputElement;
    this.searchBox = new google.maps.places.SearchBox(input);
    this.map.addListener('bounds_changed', () => {
      this.searchBox.setBounds(this.map.getBounds() as google.maps.LatLngBounds);
    });
    this.searchBox.addListener('places_changed', () => {
      const places = this.searchBox.getPlaces();
      if (!places || places.length === 0) {
        alert('No places found');
        return;
      }
      const place = places[0];
      if (place.geometry && place.geometry.location) {
        const location = place.geometry.location;
        this.addMarker(location);
        this.fetchAddress(location);
      }
    });
    this.map.addListener('click', (event: google.maps.MapMouseEvent) => {
      if (event.latLng) {
        this.addMarker(event.latLng);
        this.fetchAddress(event.latLng);
      }
    });
    setTimeout(() => {
      this.loadSavedLocation();
    }, 300);
  }
  addMarker(position: google.maps.LatLng): void {
    if (!this.map) {
      console.warn('Map not initialized yet. Marker not added.');
      return;
    }

    if (this.marker) {
      this.marker.setPosition(position);
    } else {
      this.marker = new google.maps.Marker({
        position,
        map: this.map,
        title: 'Selected Location',
      });
    }

    this.lat = position.lat();
    this.lng = position.lng();
    this.coordinates = `${this.lat}, ${this.lng}`;
    this.map.setCenter(position);
  }

  fetchAddress(latLng: google.maps.LatLng): void {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: latLng }, (results: any, status: any) => {
      if (status === 'OK' && results && results[0]) {
        this.address = results[0].formatted_address || 'Address not found';
        const addressComponents = results[0].address_components;

        this.city = addressComponents.find((c: any) =>
          c.types.includes('locality')
        )?.long_name || '';
        this.state = addressComponents.find((c: any) =>
          c.types.includes('administrative_area_level_1')
        )?.long_name || '';
        this.zip = addressComponents.find((c: any) =>
          c.types.includes('postal_code')
        )?.long_name || '';
        this.country = addressComponents.find((c: any) =>
          c.types.includes('country')
        )?.long_name || '';

        this.cdr.detectChanges();
        // this.saveLocation();
      } else {
        console.error('Failed to fetch address:', status);
      }
    });
  }

  saveLocation(): void {
    const mapLocationData = this.formstate.getFormData('map-location');
  const fallbackAddress = mapLocationData?.address || '';
    if (!this.lat || !this.lng || !this.address) {
      console.warn('Incomplete location data, not saving.');
      return;
    }

    const locationData = {
      latitude: this.lat,
      longitude: this.lng,
      address: this.address || fallbackAddress,
      city: this.city,
      state: this.state,
      zip: this.zip,
      country: this.country,
    };
    const postLocation = {
      latitude: this.lat.toString(),
      longitude: this.lng.toString(),
    }
    console.log('Full location data:', locationData);
    console.log('Post location data:',this.address);
    this.formStateService?.setFormData?.('map-location', locationData);
    this.formStateService?.setLocationDetails?.(postLocation);
    console.log('Location saved via setLocationDetails:', locationData);

    // this.toastService.showToast('Location Details saved Successfully', 'success');
    this.nextSection.emit();
  }

  resetForm(): void {
    this.formstate.setFormData('map-location', null);
    this.lat = 0;
    this.lng = 0;
    this.address = '';
    this.city = '';
    this.state = '';
    this.zip = '';
    this.country = '';
    this.marker?.setMap(null);
    console.log('Map location data reset.');
  }
  populateLocationFromBackend(res: any): void {
    if (!res) return;

    const latitude = parseFloat(res.latitude);
    const longitude = parseFloat(res.longitude);
    const mapLocationData = this.formstate.getFormData('map-location');
    const address = res.address || mapLocationData?.address || '';
    // const address = res.address || '';

    if (!latitude || !longitude) {
      console.warn('Invalid coordinates received from backend.');
      return;
    }

    this.lat = latitude;
    this.lng = longitude;
    this.address = address;

    const position = new google.maps.LatLng(this.lat, this.lng);
    this.addMarker(position);
    this.map.setCenter(position);
    this.coordinates = `${this.lat}, ${this.lng}`;

    // this.fetchAddress(position);

    this.cdr.detectChanges();
  }

}